<script setup>
import { computed } from "vue"
import { useAuthStore } from "@/stores"

defineOptions({ inheritAttrs: false })

const props = defineProps({
  user:          { required: true },
  showAvatar:    { type: Boolean, default: true },
  linkable:      { type: Boolean, default: true },
  showFullName:  { type: Boolean, default: true },
  showShortName: { type: Boolean, default: false },
  path:          { type: String,  default: '' },
  query:         { type: Object,  default: () => ({}) },
  target:        { type: String,  default: null },
})

const { currentUser } = useAuthStore()

const isLinkEnabled = computed(() => {
  return props.linkable && currentUser.isManager
})

</script>

<template lang="pug">
div
  template(v-if="user")
    RouterLink.text-link(
      v-if="isLinkEnabled"
      :to="{ path: '/user/' + user.id + path, query: query }"
      :target="target"
    )
      UserAvatar(
        :user="user"
        :showAvatar="showAvatar"
        :showFullName="showFullName"
        :showShortName="showShortName"
        :size="$attrs.size"
        :class="$attrs.class"
      )
    UserAvatar(
      v-else
      :user="user"
      :showAvatar="showAvatar"
      :showFullName="showFullName"
      :showShortName="showShortName"
      :size="$attrs.size"
      :class="$attrs.class"
    )
  template(v-else)
    .flex.gap-2.items-center
      Avatar(
        v-if="showAvatar"
        shape="circle" 
        icon="ph ph-user" 
        style="background-color: #9ca3af; color: #ffffff;"
      )
      .text-sm.text-canvas-400.italic(v-if="showFullName || showShortName") --No User--     
</template>